import { Injectable, OnDestroy } from '@angular/core';

import { MembershipListType } from 'libs/domain';

import { ListMembershipService } from '@app/src/app/services/ListMembership';
import { SystemAlertSnackBarService } from '@app/src/app/shared/components/system-alert-snackbar';

@Injectable()
export class FtmRestrictionsService implements OnDestroy {
  // Component Constructor

  constructor(
    private _listMembership: ListMembershipService,
    private _systemAlertSnackBar: SystemAlertSnackBarService,
  ) {}

  // Lifecycle Hooks

  ngOnDestroy(): void {}

  // Public Methods

  public async fetchList() {
    await this._getListData();
  }

  // Private Methods

  private async _getListData() {
    try {
      const lists = await this._listMembership.getMembershipListByType([MembershipListType.FLEX_NO_REGISTRATION]);
      if (lists.length === 0) await this._createMissingList();
    } catch (error) {
      this._systemAlertSnackBar.error(error);
    }
  }

  private async _createMissingList() {
    await this._listMembership.getOrCreateMembershipLists([MembershipListType.FLEX_NO_REGISTRATION]);
  }
}
